export const maanedListe = [
  "januar",
  "februar",
  "mars",
  "april",
  "mai",
  "juni",
  "juli",
  "august",
  "september",
  "oktober",
  "november",
  "desember",
];
export const MND_SIDEN_SYKMELDING_GRENSE_FOR_OPPFOELGING = 4;

export const KANGJENNOMFOERES = {
  KAN: "KAN",
  KAN_IKKE: "KAN_IKKE",
  TILRETTELEGGING: "TILRETTELEGGING",
  IKKE_VURDERT: "IKKE_VURDERT",
};

export const TILRETTELEGGING = {
  PAA_ANNET_STED: "PAA_ANNET_STED",
  MED_MER_TID: "MED_MER_TID",
  MED_HJELP: "MED_HJELP",
};

export const STATUS = {
  AKTIV: "AKTIV",
  AVBRUTT: "AVBRUTT",
  UNDER_ARBEID: "UNDER_ARBEID",
  UTDATERT: "UTDATERT",
};

export const STATUS_TILTAK = {
  FORSLAG: "FORSLAG",
  AVTALT: "AVTALT",
  IKKE_AKTUELT: "IKKE_AKTUELT",
  AVBRUTT: "AVBRUTT",
};
